export default __webpack_public_path__ + "static/media/road-C-photo.a1f5b858.svg";